import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, inr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, MessageCircle, Truck, Package, Instagram } from "lucide-react";

export default function OrderSuccess() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);
  const [ig, setIg] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/orders/track/${orderNumber}`).then((r) => setOrder(r.data)).catch(() => {});
    api.get("/config").then((r) => setIg(r.data.instagram || "")).catch(() => {});
  }, [orderNumber]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center">
      <div className="fade-up">
        <CheckCircle2 className="w-20 h-20 text-emerald-600 mx-auto" />
        <h1 className="font-serif text-3xl lg:text-4xl font-bold text-rose-950 mt-6">Order Placed Successfully!</h1>
        <p className="text-muted-foreground mt-3">Thank you for shopping with Million Pixels. Your order confirmation has been sent to your WhatsApp.</p>
        <div className="bg-white border border-rose-900/15 rounded-2xl p-6 mt-8 text-left">
          <div className="flex justify-between items-center">
            <div><p className="accent-label">Order ID</p><p className="font-serif text-2xl font-bold text-rose-950" data-testid="success-order-number">{orderNumber}</p></div>
            {order && <p className="font-serif text-xl font-semibold text-rose-950">{inr(order.total)}</p>}
          </div>
          <div className="grid grid-cols-3 gap-3 mt-6 text-center text-xs">
            {[[Package, "Order Placed", "done"], [MessageCircle, "WhatsApp Sent", "done"], [Truck, "Shiprocket Pickup", "next"]].map(([Icon, t, state], i) => (
              <div key={i} className={`flex flex-col items-center gap-2 ${state === "done" ? "text-emerald-600" : "text-muted-foreground"}`}>
                <Icon className="w-6 h-6" />{t}
              </div>
            ))}
          </div>
        </div>
        <div className="flex gap-3 justify-center mt-8">
          <Link to={`/track/${orderNumber}`}><Button className="bg-rose-950 hover:bg-rose-900 rounded-full h-12 px-6" data-testid="success-track-btn">Track Order</Button></Link>
          <Link to="/shop"><Button variant="outline" className="rounded-full h-12 px-6 border-rose-950/30">Continue Shopping</Button></Link>
        </div>
        {ig && (
          <a href={ig} target="_blank" rel="noreferrer" className="mt-8 flex items-center justify-center gap-3 bg-gradient-to-r from-rose-950 to-amber-700 text-amber-50 rounded-2xl py-5 px-6 hover:opacity-95 transition-opacity" data-testid="success-instagram-follow">
            <Instagram className="w-6 h-6" />
            <span className="font-serif text-base lg:text-lg font-semibold">Follow @millionpixels23 for new drops, offers & styling tips</span>
          </a>
        )}
      </div>
    </div>
  );
}
